import axios from 'axios';

import type { AxiosResponse } from 'axios';

import type { Folder } from '@/types';

import { AUTOCOMPLETE_ENTRIES_LIMIT } from '@/libs/consts';

const FOLDERS_URL = '/api/v3/folders';

/**
 * Папок у пользователя мало, поэтому список запрашивается разом, без серверного поиска.
 */
const listParams = (folderableType: string): Record<string, unknown> => ({
  'filter[folderable_type]': folderableType,
  sort: 'name',
  per_page: AUTOCOMPLETE_ENTRIES_LIMIT,
});

/**
 * Запросы к API папок.
 *
 * Обработка ошибок и уведомления остаются на местах вызова: в диалоге управления ошибка
 * показывается построчно, в пикере — под полем, в списке кампаний — тостом.
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export default () => {
  const fetchFolders = (folderableType: string): Promise<AxiosResponse> => axios.get(
    FOLDERS_URL,
    { params: listParams(folderableType) },
  );

  const fetchFolderOptions = (folderableType: string): Promise<AxiosResponse> => axios.get(
    `${FOLDERS_URL}/options`,
    { params: listParams(folderableType) },
  );

  const createFolder = (folderableType: string, name: string): Promise<AxiosResponse<Folder>> => axios.post(
    FOLDERS_URL,
    {
      folderable_type: folderableType,
      name,
    },
  );

  const renameFolder = (id: number, name: string): Promise<AxiosResponse<Folder>> => axios.put(`${FOLDERS_URL}/${id}`, { name });

  const deleteFolder = (id: number): Promise<AxiosResponse> => axios.delete(`${FOLDERS_URL}/${id}`);

  /**
   * Задаёт папки кампании. Сама кампания при этом не меняется — правится только раскладка.
   */
  const setCampaignFolders = (campaignId: number, folderIds: number[]): Promise<AxiosResponse> => axios.put(
    `/api/v3/campaigns/${campaignId}/folders`,
    { folder_ids: folderIds },
  );

  return {
    fetchFolders,
    fetchFolderOptions,
    createFolder,
    renameFolder,
    deleteFolder,
    setCampaignFolders,
  };
};
